module.exports = __webpack_public_path__ + "img/brooks.c2f9774b.png";